<template>
    <section class="content">
        <div class="box-body">
            <div :class="addButtonClass">
                    <router-link :to="{ name: 'createSegregationTrip' }">
                        <button class=" btn gradientbt">Add New</button>
                    </router-link>
                </div>
            <v-server-table ref="secondaryTable" url :limit="5" :columns="columns" :options="options"
                @loaded="onLoaded">
                <template slot="beforeBody">
                    <tr v-if="loading" class="VueTables__no-results">
                        <td class="text-center" colspan="6">
                            <pulse-loader></pulse-loader>
                        </td>
                    </tr>
                </template>
            </v-server-table>
        </div>
    </section>
</template>

<script>
import {
    eventBus,
    transportService
} from '../../../services';
import {
    USER_ROLES
} from '../../../config';
import {
    ServerTable,
    Event
} from 'vue-tables-2';
import {
    mapState
} from 'vuex';

import store from '../../../store';
import swal from 'sweetalert2';
import moment from 'moment';

export default {
    name: 'secondary',
    data() {
        return {
            loading: null,
            secondaryTable: null,
            wasteTransferFormTable: null,
            columns: ['segregationPlant', 'destinationLocation', 'secondaryVehicle', 'wasteWeight', 'status', 'startDate', 'action'],
            options: {
                highlightMatches: true,
                headings: {
                    segregationPlant: 'Segregation Plant',
                    destinationLocation: 'Destination Location',
                    secondaryVehicle: 'Secondary Vehicle',
                    wasteWeight: 'Waste Weight',
                    status: 'Status',
                    startDate: 'Start Date',
                    action: 'Actions'
                },
                perPage: 10,
                sortable: ["cityId", "cityName", "firstName", "lastName", "email", "mobile", "createdAt", "status", "action"],
                requestFunction: request => {
                    const params = {
                        // $embed: ['user']
                    };
                    params.$page = request.page;
                    params.$limit = request.limit;
                    if (request.query) {
                        params.$term = request.query;
                    }
                    if (request.query.status) {
                        params.status = request.query.status;
                    };
                    this.loading = true;
                    return this.$transportDataRepository.list(params).catch(error => {
                        console.error('Transport.requestFunction-error:', error);
                    });
                },

                responseAdapter: response => {
                    this.loading = false;
                    return {
                        data: response.data.docs,
                        count: response.data.items.total,
                    };
                },

                customFilters: [{
                    name: 'custom_filter',
                    callback: function (row, query) {
                        //	return row.role[0] == query;
          
                    },
                },],
                uniqueKey: '_id',
                },
            };
        },
            computed: {
                addButtonClass() {
                    if (this.secondaryTable) {
                        return this.secondaryTable.count > this.secondaryTable.limit ||
                            this.secondaryTable.limit > 10 ?
                            'shift-add-left' :
                            'add-item';
                    } else {
                        return 'add-item';
                    }
                },
                ...mapState({
                    user: state => state.auth.user,
                }),
            },
            methods: {
                onLoaded() {
                    this.secondaryTable = this.$refs.secondaryTable;
                },
                clearFilter() {
                    this.custom_filter_select = '';
                },
                applyFilter(filter_val) {
                    Event.$emit('vue-tables.customFilters::custom_filter', filter_val);
                },
            },
};
</script>

<style>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
    background: #3085d6;
    color: white;
}

.toggle {
    cursor: pointer;
    display: inline-block;
}

.toggle-switch {
    display: inline-block;
    background: #ccc;
    border-radius: 16px;
    width: 48px;
    height: 21px;
    position: relative;
    vertical-align: middle;
    transition: background 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
    content: "";
}

.toggle-switch:before {
    display: block;
    background: linear-gradient(to bottom, #fff 0%, #eee 100%);
    border-radius: 50%;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
    width: 15px;
    height: 15px;
    position: absolute;
    top: 3px;
    left: 4px;
    transition: left 0.25s;
}

.active_wrp {
    display: flex;
    align-items: center;
}

.active_wrp a {
    flex: 0 0 30%;
    color: #3085d6;
    margin-right: 5px;
}

.gradientbt:hover {
    color: #3085d6;
    background: #fff;
    border: 2px solid #3085d6;
}

.toggle:hover .toggle-switch:before {
    background: linear-gradient(to bottom, #fff 0%, #fff 100%);
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}

.toggle-checkbox:checked+.toggle-switch {
    background: #3085d6;
}

.toggle-checkbox:checked+.toggle-switch:before {
    left: 30px;
}

.toggle-checkbox {
    position: absolute;
    visibility: hidden;
}

.toggle-label {
    margin-left: 5px;
    position: relative;
    top: 2px;
}

/* new css */

.toggle {
    --width: 64px;
    --height: calc(var(--width) / 3);

    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
}

.toggle input {
    display: none;
}

.toggle .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--height);
    background-color: #ccc;
    transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--height));
    height: calc(var(--height));
    border-radius: calc(var(--height) / 2);
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
    background-color: #3085d6;
}

.toggle input:checked+.slider::before {
    transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-family: sans-serif;
    transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
    content: attr(data-off);
    position: absolute;
    right: 5px;
    color: #4d4d4d;
    opacity: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
    content: attr(data-on);
    position: absolute;
    left: 5px;
    color: #ffffff;
    opacity: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
    opacity: 0;
}

.toggle input:checked~.labels::before {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// segregationTrip.vue?48e64338